/* Extra fields and additional questions functionality */
(function ($) {
    $('[data-extra-information="true"] input[type="checkbox"]').on('change', function () {
        var $checkbox = $(this);
        var checked = $(this).prop('checked');
        if (checked) {
            $checkbox.closest('div').find('.extra-information').show();
        } else {
            $checkbox.closest('div').find('.extra-information').hide();
        }
    });

    $('[data-additional-questions="true"] input[type="checkbox"]').on('change', function () {
        var $checkbox = $(this);
        var checked = $(this).prop('checked');
        if (checked) {
            $checkbox.closest('div').find('.extra-questions').show();
        } else {
            $checkbox.closest('div').find('.extra-questions').hide();
        }
    });

    $('.extra-questions .form-group button').on('click', function () {
        var $button = $(this);
        var $createdQuestions = $('.created-questions .questions');
        var $question = $button.parent().prev().find('input');
        var questionValue = $question.val();
        if (questionValue === '') {
            $button.parent().next().addClass('show');
        } else {
            var $questionItem = createHiddenQuestionItem(questionValue);
            $createdQuestions.append($questionItem);
            $question.val('');
            $button.parent().next().removeClass('show');
        }
    });

    $('.extra-questions').on('click', '.remove-question', function () {
        var $questionItem = $(this).closest('.question-item');
        $questionItem.remove();
    });

    $('#submit_button').on('click', function (e) {
        if ($('[data-additional-questions="true"] input[type="checkbox"]').prop('checked') === true) {
            if ($('.question-item').length === 0) {
                $('.created-questions').find('.field-validation-error').addClass('show');
                e.preventDefault();
            } else {
                $('.created-questions').find('.field-validation-error').removeClass('show');
            }
        }
    });

    function createHiddenQuestionItem(value) {
        var questionItem = document.createElement('div');
        questionItem.className = 'question-item';

        var question = document.createElement('input');
        question.type = 'hidden';
        question.name = 'AdditionalQuestions';
        question.value = value;

        var questionTitle = document.createElement('p');
        questionTitle.textContent = value;
        questionTitle.className = 'question-title';

        var removeQuestion = document.createElement('button');
        removeQuestion.className = 'remove-question';
        removeQuestion.textContent = 'Remove';
        removeQuestion.type = 'button';

        questionTitle.appendChild(removeQuestion);
        questionItem.appendChild(questionTitle);
        questionItem.appendChild(question);

        return questionItem;
    }
})(jQuery);